import { handlePageLoadError } from "#lib/api/error.js";
import type { LayoutLoadEvent } from "./$types";

export async function load(event: LayoutLoadEvent) {
	try {
		return {
			...event.data,
			user: event.data.user,
		};
	} catch (e) {
		throw handlePageLoadError(e, event.route.id, event.params);
	}
}
